import { z } from 'zod'

import {
  type Entity,
  emailSchema,
  entitySchema,
  timestampSchema,
} from '@/utility/utility'

/** Store passwords in a separate collection to prevent accidental queries */
export type UserPassword = Entity & {
  /** The Argon2id hashed password */
  passwordHash: string | null
  /** @deprecated Legacy password fields */
  salt: string | null
  /** @deprecated PK hash */
  password: string | null
  /** @deprecated Expiry for the legacy password */
  passwordDeprecatedExp: number | null
}

export const userPasswordSchema = entitySchema
  .extend({
    passwordHash: z.string().nullable().default(null),
    salt: z.string().nullable().default(null),
    password: z.string().nullable().default(null),
    passwordDeprecatedExp: z.number().nullable().default(null),
  })
  .overwrite((d) => {
    if (d.passwordHash) {
      d.password = null
      d.salt = null
      d.passwordDeprecatedExp = null
    }

    return d
  })
  .meta({ id: 'user-password' }) satisfies z.ZodType<UserPassword>

export const emailSignupOtpSchema = entitySchema
  .extend({
    email: emailSchema,
    otp: z.string().min(6).max(6),
    otpClientId: z.string(),
    exp: timestampSchema,
  })
  .meta({ id: 'email-signup-otp' })

export type EmailSignupOtp = z.infer<typeof emailSignupOtpSchema>
